import { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { ButtonWithBranding } from '../ButtonWithBranding';
import { getPageThumbnailStyles } from '../../utils/getPageThumbnailStyles';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThumbnailImage = styled.img.withConfig({
  displayName: "ViewPageDrawerItem__ThumbnailImage",
  componentId: "t0no5m-0"
})(({
  theme: _theme,
  extraStyles
}) => {
  const theme = _theme;
  return Object.assign({
    marginBlockEnd: theme.space[200],
    transition: 'border-color 300ms ease',
    height: '100px',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: '3px',
    borderColor: theme.color['border-core-on-fill-default'],
    boxSizing: 'content-box'
  }, extraStyles);
});
const ViewPageDrawerItem = ({
  imageUrl,
  selected,
  index,
  onClick,
  brandingColor
}) => {
  const imgStyles = useMemo(() => {
    return getPageThumbnailStyles(selected, brandingColor);
  }, [selected, brandingColor]);
  return /*#__PURE__*/_jsx(ButtonWithBranding, {
    margin: "200",
    onClick: onClick,
    tabIndex: selected ? 1 : 0,
    "aria-label": I18n.text('a11y.pageSelectorButton', {
      pageNumber: index + 1
    }),
    hasBorder: false,
    isTransparentOnHover: false,
    buttonPaddingInline: "0px",
    buttonPaddingBlock: "0px",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(ThumbnailImage, {
        src: imageUrl,
        extraStyles: imgStyles
      }), /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-100",
        color: "icon-core-subtle",
        children: index + 1
      })]
    })
  });
};
ViewPageDrawerItem.propTypes = {
  brandingColor: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
};
export default ViewPageDrawerItem;